import { platformApi } from "@/api/http";

export interface StaffMember {
  id: number;
  firstName: string;
  lastName: string;
  email?: string;
  acceptingAppointments?: boolean;
}

export interface TimeSlot {
  time: string;
  available: boolean;
}

const basePath = (businessId: string) =>
  `/api/v1/businesses/${businessId}/users`;

export const teamApi = {
  getMembers: async (businessId: string): Promise<StaffMember[]> => {
    const { data } = await platformApi.post(`${basePath(businessId)}/search`, { term: "" });
    const arr = Array.isArray(data) ? data : [];
    return arr.map((u: Record<string, unknown>) => ({
      id: Number(u.id ?? 0),
      firstName: String(u.firstName ?? u.first_name ?? ""),
      lastName: String(u.lastName ?? u.last_name ?? ""),
      email: (u.email as string) ?? undefined,
      acceptingAppointments: u.acceptingAppointments !== false,
    }));
  },

  getAvailability: async (
    businessId: string,
    userId: number,
    date: string,
    durationMinutes: number,
  ): Promise<TimeSlot[]> => {
    const { data } = await platformApi.get(
      `${basePath(businessId)}/${userId}/availability`,
      { params: { date, durationMinutes } },
    );
    return Array.isArray(data) ? data : [];
  },
};
